import { useState, useEffect, useRef } from 'react';

import { BaseMap } from 'components/common';
import { SearchConsole } from 'components/crops/SearchConsole';
import { Map } from 'ol';
import mapState from 'state/mapState';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useForm } from 'react-hook-form';
import CropApi from 'api/CropApi';
import ApiMapper from 'constant/ApiMapper';
import { CommonDataState } from 'state/commonState';
import { Crop } from '@crops';
import MapTools from 'packages/ui/src/components/MapTools';
import { JgaOptions } from 'packages/ui/src/libs/Map';

import { MapLayerSetting, MapLegend } from 'packages/ui/src/components';
import { useCallback } from 'react';
import { TStateMap } from '@metadata';
import RightPannel from 'components/crops/RightPannel';
import pannelState from 'state/rightPannelState';
import loadLayerState from 'state/loadLayerState';
import CoordToAddrLayout from '../../components/common/CoordToAddrLayout';
import env from 'config/env';
import CropMap from 'CropMap';
import EtcUtils from 'packages/ui/src/libs/EtcUtils';
import { filter, map } from 'rxjs';

const mapper = ApiMapper.CROP;

function CropViewer() {
  const {
    control,
    handleSubmit,
    resetField,
    setValue,
    register,
    formState: { errors },
  } = useForm<Crop.FormData>({
    defaultValues: {
      sggCd: '0',
      emdCd: '0',
      ctpvCd: '0',
      searchAddr: '',
      detId: '',
      prjId: '',
      gubun: '10',
      pageNo: 0,
      pageSize: 10,
      sameCd: '0',
      treeKindCd:'0'
    },
  });

  const mapRef = useRef<Map>(null);
  const [mapInfo, setMap] = useRecoilState(mapState);
  const common = useRecoilValue(CommonDataState);
  const { status } = useRecoilValue(pannelState);
  const [jga, setJga] = useState<CropMap>(null);
  const [pannel, setPannel] = useRecoilState(pannelState);
  const [data, setData] = useState<{
    values?: Crop.FormData;
    aiStat?: Crop.TStat[];
    aiDetailList?: Crop.TAiListResponse;
  }>({});
  const { ctpv, sgg , emd } = useRecoilValue(CommonDataState);

  const [loadLayer, setLoadLayer] = useRecoilState(loadLayerState);

  const [openBtn, setOpenBtn] = useState(false); //X버튼 컨트롤

  const [detail, setDetail] = useState(false); //디테일 메뉴 오픈 유무

  useEffect(() => {
    if (jga) return;
    const options: JgaOptions = {
      domId: 'crop_map',
      mapRef,
    };
    const _jga = new CropMap(options);

    setJga((prev) => _jga);
    _jga.init();
  }, []);

  useEffect(() => {
    const subscription = EtcUtils.observer.mapInteraction.subject
      .pipe(map((i: any) => i?.message))
      .subscribe((mes: any) => {
        moveToDetail(mes);
      });

    return () => {
      subscription.unsubscribe();
    };
  }, [jga]);

  useEffect(() => {
    if (mapInfo.status.obj_id) {
      jga.onlyDrawStroke(mapInfo.status.obj_id);
    }
  }, [mapInfo.status.obj_id]);

  const moveToDetail = (e: Crop.TAiListData) => {

    setPannel((prev) => ({
      ...prev,
      status: {
        ...prev.status,
        isFold: false,
        aiDetail: {
          isOpen: true,
          data: {
            // farmMapId: id,
            area: e.area,
            addr: e.addr,
          },
          detailType: 'ai',
        },
      },
    }));
  };



  useEffect(() => {
    if (status.currentDetId) {
      setLoadLayer((prev) => ({
        data: {
          ...prev.data,
          detId: status.currentDetId,
        },
      }));
    }
  }, [status.currentDetId]);

  const clearDataHandler = () => {
    setPannel((prev) => ({
      ...prev,
      status: {
        ...prev.status,
        currentPage: 'ai',
        isOpen: false,
        aiTransition: { isOpen: false },
        aiDetail: { isOpen: false, data: {} },
      },
    }));
  };

  const onSubmit = useCallback(
    async (formData: Crop.FormData) => {
      try {
        console.log(formData);
        clearDataHandler();
        if (mapInfo.status.loadStart) {
          console.log('---- loading .... -----');
          return;
        }
        setMap((prev: TStateMap) => ({ ...prev, status: { ...prev.status, loadStart: true } }));
        await callBoundary(formData);
        await callAiFeature(formData);

        // await callAiFeature(formData);

        setMap((prev: TStateMap) => ({ ...prev, status: { ...prev.status, loadStart: false } }));
        setPannel((prev) => ({ ...prev, status: { ...prev.status, isOpen: true, isFold: false } }));
        setPannel((prev) => ({
          ...prev,
          status: { ...prev.status, currentDetId: formData.detId, currentPrjId: formData.prjId },
        }));

        console.log(emd);
     
        setData({
          values: {
            ctpvCd: formData.ctpvCd,
            sggCd: formData.sggCd,
            emdCd: formData.emdCd,
            treeKindCd: formData.treeKindCd,
            ctpvNm: formData.ctpvCd === '0' ? '전체' : ctpv.filter((i) => i.ctpv_cd === formData.ctpvCd)[0].ctpv_nm,
            sggNm: formData.sggCd === '0' ? '' : sgg.filter((i) => i.sgg_cd === formData.sggCd)[0].sgg_nm,
            emdNm: formData.emdCd === '0' ? '' : emd.filter((i) => i.emd_cd === formData.emdCd)[0].emd_nm,
          },
        });

        setLoadLayer({
          data: {
            sggCd: formData.sggCd,
            emdCd: formData.emdCd,
            treeKindCd: formData.treeKindCd,
            detId: formData.detId,
            searchAddr: formData.searchAddr,
          },
        });
      } catch (e) {
        console.error(e);
        setMap((prev: TStateMap) => ({ ...prev, status: { ...prev.status, loadStart: false } }));
      }
    },
    [mapInfo, jga],
  );

  const callBoundary = async (data: Crop.FormData) => {
    // console.log(data);
    if (data.ctpvCd === '0') return;
    try {
      if (data.emdCd !== '0') {
        // 동 선택되었을 경우.
        const emdGeo = await CropApi.GeoJson({ url: mapper.GEO.EMD, regionCode: data.emdCd });
        // console.log(emdGeo);
        jga.drawBorder(emdGeo);
        return emdGeo;
      }else if (data.sggCd !== '0') {
        // 시 선택되었을 경우.
        const sggGeo = await CropApi.GeoJson({ url: mapper.GEO.SSG, regionCode: data.sggCd });
        jga.drawBorder(sggGeo);
        return sggGeo;
      }
      // 시만 선택되었을 경우.
      const ctpvGeo = await CropApi.GeoJson({ url: mapper.GEO.CTPV, regionCode: data.ctpvCd });
      jga.drawBorder(ctpvGeo);
      return ctpvGeo;
    } catch (e) {
      console.log(e);
    }
  };

  const callAiFeature = async (formData: Crop.FormData) => {

    try {
      const result = await CropApi.AiFeatures({
        url: mapper.GEO.AI_LIST,
        ctpvCd: formData.ctpvCd,
        treeKindCd: formData.treeKindCd,
        sggCd: formData.sggCd,
        emdCd: formData.emdCd,
        searchAddr: formData.searchAddr,
      });
      
      jga.drawAiFeatures(result);
      return result;
    } catch (e) {

      jga.clearAiMap();
    }
  };

  useEffect(() => {
    if (!pannel) {
      setData({});
    }
  }, [pannel]);

  return (
    <div className="cWrap">
      <div className="cMap">
        {/* map */}
        <BaseMap />
        <article className="mapLayerArea">
          <div className="mapLayerLine00">
            <SearchConsole
              register={register}
              control={control}
              formError={errors}
              onSubmit={handleSubmit(onSubmit)}
              resetField={resetField}
              detail={detail}
              openBtn={openBtn}
              setDetail={setDetail}
              setOpenBtn={setOpenBtn}
              setValue={setValue}
              t_name="AI 탐지 조회"
            />
            <MapLegend
              title="임산품 품종 범례"
              item={common.legend}
            />
          </div>
          <MapTools jgaMap={jga} />
          <MapLayerSetting jgaMap={jga} />
          <CoordToAddrLayout
            jgaMap={jga}
            emdList={common.emd}
          />
          <RightPannel
            data={data}
            setValue={setValue}
            onSubmit={onSubmit}
            control={control}
          />
        </article>
      </div>
    </div>
  );
}
export default CropViewer;
